import { render, staticRenderFns } from "./ProductsDetails.vue?vue&type=template&id=7dbe9d00&scoped=true"
import script from "./ProductsDetails.vue?vue&type=script&lang=js"
export * from "./ProductsDetails.vue?vue&type=script&lang=js"
import style0 from "./ProductsDetails.vue?vue&type=style&index=0&id=7dbe9d00&prod&lang=scss&scoped=true"
import style1 from "./ProductsDetails.vue?vue&type=style&index=1&id=7dbe9d00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbe9d00",
  null
  
)

export default component.exports